<template>
  <RouterLink
    v-if="!disabled"
    :to="{ name: routeName }"
    class="group flex flex-row items-center squircle-xl rounded-md px-2.5 py-1.5 transition-all hover:bg-primary-400 hover:text-white dark:text-white"
    :class="{
      'bg-primary-500 font-medium text-white hover:bg-primary-500 hover:text-white':
        isActive
    }"
  >
    <div class="shrink-0">
      <FontAwesomeIcon :icon="['fas', icon]" fixed-width />
    </div>
    <span class="ml-3 flex-1 cursor-pointer truncate capitalize-first">
      {{ label }}
    </span>
  </RouterLink>
  <div
    v-else
    class="flex flex-row items-center px-2.5 py-1.5 text-gray-400 dark:text-slate-400"
  >
    <div class="shrink-0">
      <FontAwesomeIcon :icon="['fas', icon]" fixed-width />
    </div>
    <span class="ml-3 flex-1 truncate capitalize-first">{{ label }}</span>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/** Work menu entry, styled as Funeral Manager's DossierNavLink. */
export default {
  name: 'WorkNavLink',
  components: { FontAwesomeIcon },
  props: {
    disabled: { type: Boolean, required: false, default: false },
    routeName: { type: String, required: true },
    /** Routes nested under this entry that keep it highlighted. */
    subRoutes: { type: Array, required: false, default: () => [] },
    icon: { type: String, required: true },
    label: { type: String, required: true }
  },
  computed: {
    isActive() {
      return [this.routeName, ...this.subRoutes].includes(this.$route.name)
    }
  }
}
</script>
